import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { castDraft } from 'immer';

import { User } from '@paragon/contract-library';

import { LoginDataSliceState } from './logInDataSlice';

export interface OrganizationMembersState {
  readonly members: readonly User[];
  readonly status: 'idle' | 'loading' | 'loaded' | 'error';
}

const initialState: OrganizationMembersState = {
  members: [],
  status: 'idle',
};

const organizationMembersSlice = createSlice({
  name: 'organizationMembers',
  initialState,
  reducers: {
    organizationMembersLoading: (state) => {
      state.status = 'loading';
    },
    organizationMembersLoaded: (state, action: PayloadAction<readonly User[]>) => {
      state.members = castDraft(action.payload);
      state.status = 'loaded';
    },
    organizationMembersFailed: (state) => {
      state.status = 'error';
    },
  },
});

export const { organizationMembersLoading, organizationMembersLoaded, organizationMembersFailed } =
  organizationMembersSlice.actions;
export const organizationMembers = organizationMembersSlice.reducer;

export interface OrganizationMembersSliceState extends LoginDataSliceState {
  readonly organizationMembers: OrganizationMembersState;
}
